import Vue from 'vue';

export default {
    register(context, input) {
        const url = 'v1/register';
        let data = new FormData();

        Object.entries(input).forEach((item) => {
            if (item[0] === 'additional_docs') {
                if (Array.isArray(item[1])) {
                    item[1].forEach((o) => {
                        if (o) {
                            data.append('additional_docs[]', o);
                        }
                    });
                } else {
                    if (item[1]) {
                        data.append('additional_docs[0]', item[1]);
                    }
                }
            }
            else if (item[0] === 'custom_fields') {
                item[1].forEach((o, i) => {
                    data.append(`custom_fields[${i}][id]`, o.id);
                    if (Array.isArray(o.value)) {
                        o.value.forEach((vo, vi) => {
                            if (vo) {
                                data.append(`custom_fields[${i}][value][${vi}]`, vo);
                            }
                        });
                    } else {
                        if (o.value) {
                            data.append(`custom_fields[${i}][value]`, o.value);
                        }
                    }
                });
            }
            else if (item[0] === 'screening_questions') {
                item[1].forEach((o, i) => {
                    data.append(`screening_questions[${i}][id]`, o.id);
                    if (Array.isArray(o.value)) {
                        o.value.forEach((vo, vi) => {
                            if (vo) {
                                data.append(`screening_questions[${i}][value][${vi}]`, vo);
                            }
                        });
                    } else {
                        if (o.value) {
                            data.append(`screening_questions[${i}][value]`, o.value);
                        }
                    }
                });
            }
            else {
                if (item[1]) {
                    if (Array.isArray(item[1])) {
                        item[1].forEach((vo, vi) => {
                            if (vo) {
                                data.append(`${item[0]}[${vi}]`, vo);
                            }
                        });
                    } else {
                        if (item[1]) {
                            data.append(item[0], item[1]);
                        }
                    }
                }
            }
        });

        return Vue.$axios.$post(url, data);
    },

    login(context, data) {
        const url = 'v1/login';
        return Vue.$axios.$post(url, data);
    },

    forgotPassword(context, data) {
        const url = 'v1/forgot-password';
        return Vue.$axios.$post(url, data);
    },

    resetPassword(context, data) {
        const url = 'v1/reset-password';
        return Vue.$axios.$put(url, data);
    },

    resetEmail(context, token) {
        const url = `v1/reset-email?token=${token}`;
        return Vue.$axios.$put(url);
    },

    seekLogin(context, data) {
        const url = 'v1/login/seek';
        return Vue.$axios.$post(url, data);
    },

    linkedInLogin(context, data) {
        const url = 'v1/login/linkedin';
        return Vue.$axios.$post(url, data);
    },

    facebookLogin(context, data) {
        const url = 'v1/login/facebook';
        return Vue.$axios.$post(url, data);
    },
};
